import { Box, Grid, useTheme, Stack, Avatar } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CAppPaper from '../../../../app/components/CAppPaper';
import CAppSubTitle from '../../../../app/components/CAppSubTitle';
import useInvestContactPicture from '../../hooks/contact/useInvestContactPicture';
import IInvestContact from '../../interfaces/contact/IInvestContact';
import investorContactLang from '../../features/contact-drawer/langs/investorContactLang';
import IFund from '../../interfaces/fund/IFund';
import useInvestFundInformations from '../../hooks/fund/useInvestFundInformations';
import IFundFilters from '../../interfaces/fund/IFundFilters';
import investmentFundQuestionLang from '../../langs/investmentFundQuestionLang';
import { langLookup } from '../../../../app/utils/langLookup';

type VInvestFundQuestionProps = {
	fund: IFund;
	filters: IFundFilters;
};

const VInvestFundQuestion = (props: VInvestFundQuestionProps) => {
	const { fund } = props;

	const { fundInformations } = useInvestFundInformations(fund ? fund.id : null);
	const { t } = useTranslation();
	return (
		<>
			{fundInformations && fundInformations.contacts ? (
				<>
					<CAppSubTitle
						title={
							<Trans
								t={t}
								i18nKey={investmentFundQuestionLang.you_have_question_on_contact_us.tag}
								values={{ fund_name: fund.name }}
							/>
						}
					/>
					<Grid container spacing={3}>
						{fundInformations.contacts &&
							fundInformations.contacts.map((contact, index) => {
								return <VFundContactItem key={index} contact={contact} />;
							})}
					</Grid>
				</>
			) : (
				''
			)}
		</>
	);
};

type VFundContactItemProps = {
	contact: IInvestContact;
};
const VFundContactItem = (props: VFundContactItemProps) => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { contact } = props;
	const sxIdentity = {
		color: theme.palette.primary.main,
		'& .MuiAvatar-root': {
			height: '60px',
			width: '60px',
		},
		'& .name': {
			fontSize: '1rem',
			lineHeight: '1.5',
			fontWeight: 600,
		},
		'& .phone': {
			cursor: 'pointer',
			color: '#6F8098',
			fontWeight: 400,
			fontSize: '0.9rem',
		},
		'& .role': {
			color: '#6F8098',
			fontWeight: 600,
			fontSize: '0.9rem',
		},
		'& .email': {
			cursor: 'pointer',
			fontWeight: 400,
			fontSize: '0.9rem',
		},
		// title: {
		// 	fontWeight: '600',
		// 	color: 'white',
		// },
		// identity: {
		// 	padding: '0px 0px 0px 0px',
		// 	fontSize: '15px',
		// 	lineHeight: '1.5rem',
		// },
	};
	const picture = useInvestContactPicture(contact.pictureTag ?? '');
	return (
		<Grid item sm={4} xs={12}>
			<CAppPaper className="fund-contact-item" variant="outlined" sx={{ padding: '25px' }}>
				<Stack direction="row" spacing={3} alignItems="center" sx={sxIdentity}>
					<Avatar src={contact.picturePublicUrl ?? (picture ? picture.toString() : undefined)} />
					<Box>
						<Box className="name">
							{contact.isMoral
								? contact.moralName
									? contact.moralName.toString()
									: ''
								: `${contact.firstname ? contact.firstname : ''} ${
										contact.lastname ? contact.lastname.toUpperCase() : ''
								  }`}
						</Box>
						{contact.isMoral && contact.phone ? (
							<Box
								className="phone"
								onClick={(e) => {
									window.location.href = 'tel:' + contact.phone.replace(/\s/g, '');
									e.preventDefault();
								}}
							>
								{contact.phone}
							</Box>
						) : (
							<Box className="role">
								{contact.roleTag && langLookup(investorContactLang, contact.roleTag)
									? t(langLookup(investorContactLang, contact.roleTag)?.tag ?? '')
									: contact.roleTag}
							</Box>
						)}
						<Box
							className="email"
							onClick={(e) => {
								window.location.href = 'mailto:' + contact.email;
								e.preventDefault();
							}}
						>
							{contact.email}
						</Box>
					</Box>
				</Stack>
			</CAppPaper>
		</Grid>
	);
};

export default VInvestFundQuestion;
